import { PermissionFields } from '@ragu-components/ord-types';

import type { ResourceProps } from 'react-admin';

export const CalendarEvents = 'calendar_events';
export const Contacts = 'contacts';
export const PersonalAccessToken = 'personal_access_tokens';
export const QueueCallSessions = 'queue_call_sessions';
export const CallRecordings = 'call_recordings';
export const PersonalCallRecordings = `me/${CallRecordings}`;

export const Resources = {
  ...PermissionFields,
  [QueueCallSessions]: QueueCallSessions,
  [Contacts]: Contacts,
  [`me/${PermissionFields.calendars}`]: `me/${PermissionFields.calendars}`,
  [`me/${CalendarEvents}`]: `me/${CalendarEvents}`,
  [`me/${PersonalAccessToken}`]: `me/${PersonalAccessToken}`,
  [`me/${PermissionFields.mobility_configurations}`]: `me/${PermissionFields.mobility_configurations}`,
  [`me/${PermissionFields.hunting_groups}`]: `me/${PermissionFields.hunting_groups}`,
  [`me/${PermissionFields.user_numbers}`]: `me/${PermissionFields.user_numbers}`,
  [CalendarEvents]: CalendarEvents,
  [CallRecordings]: CallRecordings,
  [PersonalCallRecordings]: PersonalCallRecordings,
};

/** Extend ReactAdmin ResourceProps options
 *
 * For more info see: https://marmelab.com/react-admin/Resource.html
 */
export interface OrdResourceProps extends ResourceProps {
  key: string;
}
